import { Grid, Typography } from "@mui/material";
import Content from "../Content";
import styles from './index.module.css';
import PricingTable from "../../PricingTable";
import { buildInvoiceProductDisplayRows } from "../../../utils/invoiceLineDisplay";
import { formatDocumentProductTitle } from "../../../utils/documentProductTitle";

const Invoice = ({ productData = {}, displayRows = null, type }) => {
  const { prices, decorations, artworks } = displayRows || buildInvoiceProductDisplayRows(productData);
  const totalQuantity = prices.reduce((sum, row) => sum + Number(row.quantity || 0), 0);
  const combinedCharges = [...decorations, ...artworks];
  return (
    <Grid container spacing={3} className={styles.presentationCardContainer}>
      <Grid className={styles.titleRow}>
        <Content title={formatDocumentProductTitle(productData.Name)} type={'Text'} />
      </Grid>
      <Grid container spacing={3} className={styles.presentationCard}>
        <Grid item xs={12} md={7} style={{ paddingLeft: '0px', paddingTop: '0px', minWidth: '100%' }}>
          <PricingTable
            priceDetails={[...prices, {
              id: '', item: 'Total Units', price: '', quantity: totalQuantity, amount: ''
            }]}
            isPo={true}
            NetCost={true}
            customerSellingPrices={true}
            isDecoration={type === "Different_supplier_decoration"}
            lineItemTaxBreakdown={true}
          />
        </Grid>
        {combinedCharges.length > 0 && (
          <Grid item xs={12} md={7} style={{ paddingLeft: '0px', paddingTop: '0px', minWidth: '100%' }}>
            <Typography className={styles.artWorkCostsTitle}>Artwork & Decoration Costs</Typography>
            <PricingTable
              priceDetails={combinedCharges}
              isPo={true}
              isArtWork={true}
              customerSellingPrices={true}
              lineItemTaxBreakdown={true}
            />
          </Grid>
        )}
      </Grid>
    </Grid>
  );
};

export default Invoice;
